import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { PostCommentLoginSubjectReactionLinksContainerModel } from '../../../../../models/aggregates/post-comment-login-subject-reaction-links';


@Injectable({
  providedIn: 'root'
})
export class PostCommentLoginSubjectReactionLinkService extends BaseApiTemplateService<PostCommentLoginSubjectReactionLinksContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comment-login-subject-reaction-links/login-entity-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comment-login-subject-reaction-links/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post-comment-login-subject-reaction-links/login-entity-ep';
    this.httpClient = http;
  }
}


